import getMessage from 'src/background/utils/i18n.utils';
import { MessageType } from '@reference-data/message-type.enum';
import React, { useEffect } from 'react';
import ButtonComponent from 'src/common-ui/button/button.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
const DEFAULT_TIMEOUT = 3000;
const MessageContainer = ({ message, onResetMessage, }) => {
    useEffect(() => {
        if (message.type !== MessageType.ERROR) {
            setTimeout(() => close(), DEFAULT_TIMEOUT);
        }
    }, []);
    const close = () => {
        onResetMessage();
    };
    const getIcon = (errorType) => {
        switch (errorType) {
            case MessageType.SUCCESS:
                return SVGIcons.MESSAGE_SUCCESS;
            case MessageType.ERROR:
                return SVGIcons.MESSAGE_ERROR;
            case MessageType.WARNING:
                return SVGIcons.MESSAGE_WARNING;
            default:
                return SVGIcons.MESSAGE_SUCCESS;
        }
    };
    const getTitle = (messageType) => {
        switch (messageType) {
            case MessageType.SUCCESS:
                return 'message_container_title_success';
            case MessageType.ERROR:
                return 'message_container_title_fail';
            case MessageType.WARNING:
                return 'message_container_title_warning';
            default:
                return 'message_container_title_success';
        }
    };
    return (React.createElement("div", { className: "message-container" },
        React.createElement("div", { className: "overlay" }),
        React.createElement("div", { className: "message-card" },
            React.createElement(SVGIcon, { icon: getIcon(message.type) }),
            React.createElement("div", { className: `title ${message.type === MessageType.SUCCESS ? 'success' : ''}` }, getMessage(getTitle(message.type))),
            React.createElement("div", { className: "message", dangerouslySetInnerHTML: {
                    __html: getMessage(message.key, message.params),
                } }),
            React.createElement(ButtonComponent, { additionalClass: message.type === MessageType.SUCCESS ? 'success-button' : '', label: "message_container_close_button", onClick: close }))));
};
export const MessageContainerComponent = MessageContainer;
